import { render, staticRenderFns } from "./TodoFollowupWithAppointment.vue?vue&type=template&id=10b0193d"
import script from "./TodoFollowupWithAppointment.vue?vue&type=script&lang=ts"
export * from "./TodoFollowupWithAppointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports